export const manejarError = (error) => {
  if (error.response) {
    // Si la respuesta del servidor fue recibida, pero hubo un error en ella
    // Código de estado 404, 500, etc
    return error.response?.data?.error|| error.response?.data?.message
  } else if (error.request) {
    // Si la solicitud fue hecha pero no hubo respuesta del servidor
    return 'No se pudo establecer conexión con el servidor. Intenta nuevamente.'
  } else {
    // Si algo falló en la configuración de la solicitud
    return 'Error al realizar la solicitud.'
  }
}
